import React, { createContext, useContext, useMemo, useState } from 'react';

interface ParishBookPersonState {
    id: string;
    categoryId: string;
    firstName: string;
    lastName: string;
    availability?: string;
    description?: string;
    phoneNumber?: string;
    email?: string;
    visibleForGuests?: boolean;
}

interface ParishBookPersonContextType {
    values: ParishBookPersonState;
    setValues: (values: Partial<ParishBookPersonState>) => void;
}

const ParishBookPersonContext = createContext<ParishBookPersonContextType | null>(null);

export const ParishBookPersonProvider = ({
    initialState,
    children,
}: {
    initialState: ParishBookPersonState;
    children: React.ReactNode;
}) => {
    const [values, setValuesState] = useState<ParishBookPersonState>(initialState);

    const setValues = (partial: Partial<ParishBookPersonState>) => {
        setValuesState((prev) => ({ ...prev, ...partial }));
    };

    const value = useMemo(() => ({ values, setValues }), [values]);

    return (
        <ParishBookPersonContext.Provider value={value}>
            {children}
        </ParishBookPersonContext.Provider>
    );
};

export const useParishBookPersonContext = () => {
    const ctx = useContext(ParishBookPersonContext);
    if (!ctx) throw new Error('useParishBookPersonContext must be used within ParishBookPersonProvider');
    return ctx;
};
